import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';
import AdminDetailList from '../AdminDetailList.js';

const DeleteUserModal = ({ isOpen, onClose, onConfirm, user, loading }) => (
  <AdminModal
    isOpen={isOpen && !!user}
    onClose={onClose}
    title="Delete User"
    actions={(
      <>
        <button className="cancel-button" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Delete User'}
        </button>
      </>
    )}
  >
    <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
      Are you sure you want to delete this user? This action cannot be undone.
    </p>
    <AdminDetailList
      rows={[
        { label: 'User Name:', value: user?.name },
        { label: 'Email:', value: user?.email },
      ]}
    />
    <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
      The user will no longer have access to the system and all their data will be removed.
    </p>
  </AdminModal>
);

export default DeleteUserModal;
